import  React from 'react'
import { Col, Row } from "reactstrap";


const PaxDetailsIndicator = props => <Row className={'mb-1em'}>
    {
        props?.paxDetails.map((option, i) => <Col key={`pax-option-${i}`} sm={4}>
            <label>{ option?.value } &nbsp; { option?.title }</label>
        </Col>)
    }
</Row>
export default PaxDetailsIndicator